import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import './App.css';
import Home from './pages/Home';
import UserLogin from './pages/UserLogin';
import FormWizard from './pages/FormWizard';
import Success from './pages/Success';
import AdminLogin from './pages/AdminLogin';
import AdminRegister from './pages/AdminRegister';
import AdminDashboard from './pages/AdminDashboard';
import PaymentSuccess from './pages/PaymentSuccess';
import BrandedEntry from './pages/BrandedEntry';

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<UserLogin />} />
          <Route path="/form" element={<FormWizard />} />
          <Route path="/success" element={<Success />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/register" element={<AdminRegister />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/payment-success" element={<PaymentSuccess />} />
          <Route path="/e/:slug" element={<BrandedEntry />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;